var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9999 3.85693C30.0391 3.85692 33.0485 4.45551 35.8563 5.61854C38.6641 6.78157 41.2154 8.48626 43.3644 10.6353C45.5134 12.7843 47.2181 15.3355 48.3812 18.1433C49.5442 20.9512 50.1428 23.9606 50.1428 26.9997C50.1428 39.7812 39.7814 50.1426 26.9999 50.1426C14.2186 50.1426 3.85712 39.7812 3.85712 26.9997C3.85712 14.2184 14.2186 3.85693 26.9999 3.85693ZM29.3143 29.3141H24.6857C18.9562 29.3141 14.0373 32.7841 11.9157 37.7375C15.2726 42.4446 20.7778 45.514 26.9999 45.514C33.222 45.514 38.7273 42.4446 42.0842 37.7372C39.9627 32.7841 35.0438 29.3141 29.3143 29.3141ZM26.9999 10.7998C23.1655 10.7998 20.0571 13.9082 20.0571 17.7426C20.0571 21.577 23.1655 24.6855 26.9999 24.6855C30.8343 24.6855 33.9428 21.577 33.9428 17.7426C33.9428 13.9082 30.8344 10.7998 26.9999 10.7998Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageIcon);
export default __webpack_public_path__ + "static/media/profile-image-icon.ab98099b2c3ffd15c36fc6daaa4e9362.svg";
export { ForwardRef as ReactComponent };